import { useQuery } from "@tanstack/react-query";
import { getPlatformUsers } from "@/api/v1-jwt/tenancy/tenancy";
import { useAuth } from "@/providers/auth";

export const usePlatformUsers = ({
  userType,
  queryKey,
  queryFn,
  enabled,
  ...config
} = {}) => {
  const filter = userType || "all";
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!id && enabled !== false;
  return useQuery({
    queryKey: ["tenancy", "users", filter],
    queryFn: async () => getPlatformUsers({ userId: id, userType }),
    staleTime: 5 * 60 * 1000,
    enabled: isEnabled,
    ...config,
  });
};
